/* eslint-disable */
const $ = jQuery.noConflict();

'use strict';
const TabsAccordion = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domScrollBtns: $('.js-tab-button'),

	/** @description Initialize */
	init: function() {
		this.tabSystem();
		if ($(window).width() < 768) {
			this.scrollToImageResponsive();
		}
		this.dropdownActivate();
		this.starRatingBoxes();
	},

	tabSystem: function() {
		let autoProgressInterval;
		let currentIndex = 0;
		const progressDuration = 3500; // 3.5 seconds
		const $section = $('.product-type-characteristics');
		const $buttons = $('.js-tab-button');
		const $images = $('.js-tab-image');
		const $descriptions = $('.js-tab-description');

		function switchTab(index, skipFade = false) {
			if (skipFade) {
				// Instant switch for initialization
				$buttons.removeClass('active');
				$images.removeClass('active').hide();
				$descriptions.removeClass('active').hide();
				$buttons.eq(index).addClass('active');
				$images.eq(index).addClass('active').show();
				$descriptions.eq(index).addClass('active').show();
			} else {
				// Fade switch
				const $currentImage = $images.filter('.active');
				const $currentDescription = $descriptions.filter('.active');

				if ($currentImage.length && !$currentImage.is($images.eq(index))) {
					$currentImage.fadeOut(300);
					$currentDescription.fadeOut(300, function() {
						$buttons.removeClass('active');
						$images.removeClass('active');
						$descriptions.removeClass('active');

						$buttons.eq(index).addClass('active');
						$images.eq(index).addClass('active').fadeIn(300);
						$descriptions.eq(index).addClass('active').fadeIn(300);
					});
				} else {
					$buttons.removeClass('active');
					$images.removeClass('active');
					$descriptions.removeClass('active');

					$buttons.eq(index).addClass('active');
					$images.eq(index).addClass('active').fadeIn(300);
					$descriptions.eq(index).addClass('active').fadeIn(300);
				}
			}
			currentIndex = index;
			resetProgress();
			startProgress();
		}

		function resetProgress() {
			$('.tab-progress-fill').css({
				'width': '0%',
				'transition': 'none'
			});
		}

		function startProgress() {
			const $activeButton = $buttons.eq(currentIndex);
			const $progressFill = $activeButton.find('.tab-progress-fill');

			if (!$progressFill.length) return;
			
			$progressFill.css({
				'width': '0%',
				'transition': 'none'
			});
			
			// Force reflow
			$progressFill[0].offsetHeight;
			
			$progressFill.css({
				'width': '100%',
				'transition': `width ${progressDuration}ms linear`
			});
		}

		function nextTab() {
			currentIndex = (currentIndex + 1) % $buttons.length;
			switchTab(currentIndex);
		}

		function startAutoProgression() {
			if (autoProgressInterval) clearInterval(autoProgressInterval);
			autoProgressInterval = setInterval(nextTab, progressDuration);
			startProgress();
		}

		function stopAutoProgression() {
			if (autoProgressInterval) {
				clearInterval(autoProgressInterval);
				autoProgressInterval = null;
			}
			resetProgress();
		}

		// Intersection Observer to start/stop auto progression
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					startAutoProgression();
				} else {
					stopAutoProgression();
				}
			});
		}, {
			threshold: 0.5 // When 50% of the section is visible
		});

		if ($section.length) {
			observer.observe($section[0]);
		}

		// Manual click handler
		$buttons.click(function() {
			const index = $(this).data('index');
			switchTab(index);
			// Restart auto progression from this tab
			startAutoProgression();
		});

		// Initialize first tab
		switchTab(0, true);
	},

	scrollToImageResponsive: function() {
		if (!this.$domScrollBtns.length) return;
		this.$domScrollBtns.on('click', function() {
			$('html, body').animate({
				scrollTop: $('.js-tab-image.active').offset().top - 200
			}, 500);
		});
	},

	dropdownActivate: function() {
		$('.js-build-tab').on('click', function() {
			if ($(this).next('.js-dropdown-el').hasClass('active-dropdown')) {
				$(this).next('.js-dropdown-el').removeClass('active-dropdown');
				$('.js-build-tab').removeClass('is-active');
			} else {
				$('.js-dropdown-el').removeClass('active-dropdown');
				$(this).next('.js-dropdown-el').addClass('active-dropdown');
				$('.js-build-tab').addClass('is-active');
			}
		});

		$('body').on('click', function(e) {
			if ($('.js-tab-col').has(e.target).length === 0) {
				$('.js-build-tab').removeClass('is-active');
				$('.js-build-tab').next('.js-dropdown-el').removeClass('active-dropdown');
			}
		});
	},

	starRatingBoxes: function() {
		const $container = $('.star-rating-section__boxes');
		const boxCount = $container.find('.star-rating-section__box').length;

		if (boxCount === 4) {
			$container.addClass('four-boxes');
		}
	}
};

export default TabsAccordion;
